import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CompanyOfficeForm } from './company-office-form';
import { CompanyVendorForm } from './company-vendor-form';
import { ExemptVendorForm } from './exempt-vendor-form';
import { VendorForm } from './vendor-form';

export class CompanyVendorOfficeForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyVendorId: FormControl<number | undefined>;
  CompanyOfficeId: FormControl<number | undefined>;
  VendorId: FormControl<number | null | undefined>;
  CompanyId: FormControl<number | null | undefined>;

  CompanyOffice: CompanyOfficeForm;
  CompanyVendor?: CompanyVendorForm;
  Vendor?: VendorForm;
  ExemptVendor?: ExemptVendorForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyVendorId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      CompanyOfficeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      VendorId: new FormControl<number | null | undefined>(null),
      CompanyId: new FormControl<number | null | undefined>(null),
      CompanyOffice: new CompanyOfficeForm()
    });
  }
}
